// extracted by mini-css-extract-plugin
export var changeIcon = "_50-4";
export var clickable = "_50-8";
export var container = "_50-0";
export var divider = "_50-7";
export var externalLinkIcon = "_50-1";
export var green = "_50-5";
export var helpCircleIcon = "_50-3";
export var iconButton = "_50-2";
export var red = "_50-6";